<template>
<div>
  <section v-show="isShow" class="con-wrapper" id="versionDetail" :info="info" :myProjectsSearchId="myProjectsSearchId">
    <div class="back">
      <router-link to="/myprojects/version">
        <svg
          width="20px"
          height="20px"
          viewBox="0 0 20 20"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <!-- Generator: sketchtool 52.4 (67378) - http://www.bohemiancoding.com/sketch -->
          <title>AF01AA84-235A-493B-9018-E8F1A08DA1DA</title>
          <desc>Created with sketchtool.</desc>
          <g
            id="DC2.3.1_My-Projects"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <g id="DC2.3.3.1.1_History-Details" transform="translate(-191.000000, -138.000000)">
              <g
                id="arrow_collapse"
                transform="translate(201.000000, 148.000000) scale(-1, 1) rotate(-90.000000) translate(-201.000000, -148.000000) translate(191.000000, 138.000000)"
              >
                <rect
                  id="Rectangle"
                  fill-opacity="0"
                  fill="#FFFFFF"
                  fill-rule="nonzero"
                  x="0"
                  y="0"
                  width="20"
                  height="20"
                ></rect>
                <path
                  d="M12.9288462,18 C12.5596154,18 12.1903846,17.8592308 11.9088462,17.5776923 L5.85115385,11.52 C5.28807692,10.9563462 5.28807692,10.0436538 5.85115385,9.48 L11.9088462,3.42230769 C12.4719231,2.85923077 13.3857692,2.85923077 13.9488462,3.42230769 C14.5119231,3.98596154 14.5119231,4.89865385 13.9488462,5.46230769 L8.91115385,10.5 L13.9488462,15.5376923 C14.5119231,16.1013462 14.5119231,17.0140385 13.9488462,17.5776923 C13.6673077,17.8592308 13.2980769,18 12.9288462,18"
                  id="btn_arrow_collapse"
                  fill="#00B5E2"
                  transform="translate(9.900000, 10.500000) rotate(-90.000000) translate(-9.900000, -10.500000) "
                ></path>
              </g>
            </g>
          </g>
        </svg>
        <span style="vertical-align: middle;color:#00b5e2;  font-weight: 500;">{{ $t('myprojectList.historyDetails.back') }}</span>
      </router-link>
    </div>
    <div v-loading="loading">
      <h1 class="detailTile">{{ titleItem(info.versionName) }}</h1>

      <div>
        <h3 class="basicInfo">{{ $t('myprojectList.historyDetails.content.basic.title') }}</h3>
        <div class="bisicInfoBox">
          <ul class="bisicInfoUl">
            <li>
              <h4>{{ $t('myprojectList.historyDetails.content.basic.name') }}</h4>
              <p>{{ info.title }}</p>
            </li>
            <li>
              <h4>{{ $t('myprojectList.historyDetails.content.basic.update') }}</h4>
              <p>{{ momentFunc(info.uploadDate) }}</p>
            </li>
            <li>
              <h4>{{ $t('myprojectList.historyDetails.content.basic.oldName') }}</h4>
              <p>{{ info.oriDownloadUrl }}</p>
            </li>
          </ul>
          <ul class="bisicInfoUl">
            <li>
              <h4>{{ $t('myprojectList.historyDetails.content.basic.size') }}</h4>
              <p>{{ info.size }}</p>
            </li>
            <li>
              <h4>{{ $t('myprojectList.historyDetails.content.basic.status') }}</h4>
              <p>{{ info.status }}</p>
            </li>
            <li>
              <h4>Package Name</h4>
              <p>{{ info.package }}</p>
            </li>
          </ul>
          <ul class="bisicInfoUl">
            <li>
              <h4>Version Code</h4>
              <p>{{ info.versionCode }}</p>
            </li>
            <li>
              <h4>Version Name</h4>
              <p>{{ info.versionName }}</p>
            </li>
          </ul>
        </div>
      </div>

      <div>
        <h3 class="basicInfo">{{ $t('myprojectList.historyDetails.content.device.title') }}</h3>
        <div class="bisicInfoBox">
          <ul class="bisicInfoUl">
            <li>
              <h4>{{ $t('myprojectList.historyDetails.content.device') }}</h4>
              <p>
                <span
                  v-for="(o, i) in info.products"
                  :key="i"
                >{{ filterFunc(i, info.products) ? o + '/' : o }}</span>
              </p>
            </li>
          </ul>
        </div>
      </div>

      <div>
        <h3 class="basicInfo">{{ $t('myprojectList.historyDetails.content.store.title') }}</h3>
        <div class="bisicInfoBox">
          <ul class="bisicInfoUl">
            <li>
              <h4>{{ $t('myprojectList.historyDetails.content.store.local') }}</h4>
              <p>
                <span
                  v-for="(o, i) in info.supportLangs"
                  :key="i"
                >{{ filterFunc(i, info.supportLangs) ? o + ',\n' : o }}</span>
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
  <div v-show="!isShow" style="padding: 220px 0px 450px 0px;">
    <h4 class="noVersionData" :class="!info.length ? 'opacityVersion' : ''">{{ $t('myprojectList.version.common.noVersion') }}</h4>
  </div>
</div>
</template>

<script>
import moment from 'moment'
moment.locale('zh-cn')

export default {
    data () {
        return {
            info: {},
            appId: '',
            verCode: null,
            loading: false,
            isShow: true
        }
    },
    mounted () {
        let secondNavItem = [
            { path: 'MyProjectsEdit', msg: 'header.secondFloor.route.name.process' },
            true,
            { path: 'MyProjectsVersionDetail', msg: 'header.secondFloor.route.name.versionHst' }
        ]
        this.$store.state.secondNavItem = secondNavItem
        this.getparams()
    },
    methods: {
        filterFunc (index, data) {
            return data.length > 1 && index < (data.length - 1)
        },
        getparams () {
            this.appId = localStorage.getItem('appId')
            this.verCode = sessionStorage.getItem('verCode')
            this.getAppVerDetail(this.appId, parseInt(this.verCode))
        },
        titleItem (title) {
            if (!title) { return `版本` }
            return `版本${title}`
        },
        getAppVerDetail (appId, verCode) {
            this.loading = true
            const path = `/developer/app/${appId}/version/${verCode}`

            this._api.request('get', path)
                .then(response => {
                    this.loading = false
                    this.info = response.data.data.payload
                    this.isShow = true
                })
                .catch(error => {
                    this.loading = false
                    this.isShow = false
                    console.log(error)
                })
        },
        momentFunc (date) {
            return moment(date).format('YYYY年MM月DD日 a h:mm:ss')
        }
    }, // moment(row.updatedAt).format('YYYY-MM-DD HH:mm:ss')
    computed: {
        myProjectsSearchId () {
            let { key, val } = this.$store.state.myProjectsSearchId
            if (key === 'MyProjectsVersionDetail') {
                let code = sessionStorage.getItem('verCode')
                this.getAppVerDetail(val, parseInt(code))
            }
            return this.$store.state.myProjectsSearchId
        }
    }
}
</script>

<style scoped>
* {
    margin: 0px;
    padding: 0px;
}
li {
    list-style: none;
}
#versionDetail {
    font-family: sans-serif;
    font-size: 12px;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.7px;
    color: #333333;
}
svg {
    vertical-align: middle;
}
.noVersionData{
    /* width: 105px; */
    display: flex;
    justify-content: center;
    margin: auto;
    height: 24px;
    font-family: sans-serif;
    font-size: 16px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.9px;
    color: #333333;
}
.opacityVersion{
    opacity: .5;
}
.bisicInfoUl h4 {
    width: 258px;
    height: 20px;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0.8px;
    margin-bottom: 5px;
}
.bisicInfoUl p {
    width: 258.3px;
    height: 25px;
    line-height: 25px;
    font-size: 14px;
    font-weight: 300;
    letter-spacing: 0.8px;
}
.bisicInfoUl li {
    margin-bottom: 20px;
}
.bisicInfoBox {
    display: flex;
    margin-bottom: 20px;
}
.con-wrapper {
    max-width: 897px;
    margin: 0px auto;
}
.back {
    width: 326px;
    height: 18px;
    font-weight: 500;
    margin: 19px 0px 2px 0px;
}
.detailTile {
    width: 349px;
    height: 56px;
    font-size: 38px;
    font-weight: 500;
    letter-spacing: 2.1px;
    margin-bottom: 30px;
}
.basicInfo {
    width: 807px;
    height: 29px;
    font-size: 20px;
    font-weight: 500;
    letter-spacing: 1.1px;
    margin-bottom: 20px;
}
</style>
